
import { FirebaseMessagingService } from '../../../application/typescript/modules/firebase-init';


class PageNotifications {
  private form: HTMLFormElement | null;
  private portSelected: HTMLInputElement | null = null;
  private thematiqueCheckboxes: NodeListOf<HTMLInputElement> = document.querySelectorAll('._NEVER_MATCHES_');
  private submitButton: HTMLButtonElement | null = null;
  private loader: HTMLElement | null = null;
  private disabledNotification: HTMLElement | null = null;
  private firebaseService: FirebaseMessagingService | null = null;

  constructor() {
    this.form = document.querySelector('[data-form-notifications]');

    if (!this.form) {
      return;
    }
    this.firebaseService = new FirebaseMessagingService();
    if (!this.firebaseService) return;
    this.portSelected = this.form.querySelector('input[name="port"]');
    this.thematiqueCheckboxes = this.form.querySelectorAll('input[name="thematique[]"]');
    this.submitButton = this.form.querySelector('button[type="submit"]');
    this.loader = this.form.querySelector('[data-form-notifications-loader]');
    this.disabledNotification = document.querySelector('[data-form-notifications-disabled]');
    this._init();
  }

  private async _init(): Promise<void> {
    if (!this.submitButton || this.thematiqueCheckboxes.length === 0 || !this.portSelected) {
      return;
    }

    this.submitButton.disabled = true;
    this.loader?.classList.add('active');
    this.form!.classList.add('page-notifications__form--loading');
    // mobileLog('init Firebase...');
    await this.firebaseService?.init();
    let topics = this.firebaseService?.getLocalTopics();
    if (!topics || topics.length === 0) {
      topics = await this.firebaseService?.getTopicsSubscribed() ?? [];
      // mobileLog('topics depuis serveur:', topics);
    } else {
      // mobileLog('topics depuis localStorage:', topics);
    }
    this.loader?.classList.remove('active');
    this.form!.classList.remove('page-notifications__form--loading');
    this.submitButton.disabled = false;
    // console.log(topics);

    if (topics && topics.length > 0) {
      this.populateCheckboxesFromTopics(topics);
    } else {
      // Si aucun thème sélectionné : il faudra au moins choisir un thème pour valider le formulaire
      this.validateForm();
      this.thematiqueCheckboxes.forEach(checkbox => {
        checkbox.addEventListener('change', () => {
          this.validateForm();
        });
      });
    }


    this.form!.addEventListener('submit', async (event) => {
      event.preventDefault();
      const permissionGranted = await this.firebaseService?.askPermission();
      if (!permissionGranted) {
        this.disabledNotification?.classList.add('active')
        if (this.submitButton) { this.submitButton.disabled = true; }
        return;
      }
      this.disabledNotification?.classList.remove('active')
      this.handleFormSubmit();
    });
  }

  private validateForm(): void {
    if (!this.submitButton) return;

    const isThematiqueValid = Array.from(this.thematiqueCheckboxes).some(cb => cb.checked);

    if (isThematiqueValid) {
      this.submitButton.disabled = false;
    } else {
      this.submitButton.disabled = true;
    }
  }

  // Populate 
  private populateCheckboxesFromTopics(topics: string[]): void {
    const currentPortSlug = this.portSelected?.value;
    if (!currentPortSlug) return;

    topics.forEach(topic => {
      const firstHyphenIndex = topic.indexOf('-');

      if (firstHyphenIndex > -1) {
        // La thématique est tout ce qui se trouve AVANT le premier tiret
        const thematiqueSlug = topic.substring(0, firstHyphenIndex);
        const portSlug = topic.substring(firstHyphenIndex + 1);

        if (portSlug === currentPortSlug) {
          const checkboxToTick = this.form?.querySelector<HTMLInputElement>(
            `input[name="thematique[]"][value="${thematiqueSlug}"]`
          );

          if (checkboxToTick) {
            checkboxToTick.checked = true;
          }
        }
      }
    });
  }
  // Submit
  private async handleFormSubmit(): Promise<void> {
    if (!this.form || !this.firebaseService || !this.submitButton) return;

    const messages = {
      sending: this.submitButton.dataset.messageSending ?? 'Enregistrement...',
      success: this.submitButton.dataset.messageSuccess ?? 'Informations enregistrées !',
      error: this.submitButton.dataset.messageError ?? 'Erreur, veuillez réessayer',
      submit: this.submitButton.dataset.messageSubmit ?? 'Valider ces informations'
    };
    const portHiddenInput = this.form.querySelector<HTMLInputElement>('input[name="port"]');
    const confirmationDiv = this.form.querySelector('[data-message-confirmation]');
    const disabledNotification = this.form.querySelector('[data-message-disabled]');
    const portNameSpans = this.form.querySelectorAll('[data-port-name]');
    const themesNameSpan = this.form.querySelector('[data-themes-name]');

    this.submitButton!.disabled = true;
    this.submitButton!.textContent = messages.sending;

    try {
      const localTopics = this.firebaseService.getLocalTopics();
      const initialTopics = localTopics.length > 0
        ? localTopics
        : await this.firebaseService.getTopicsSubscribed() ?? [];

      const portSlug = this.portSelected?.value;
      if (!portSlug) throw new Error("Le slug du port est manquant.");

      const newTopics = Array.from(this.thematiqueCheckboxes)
        .filter(cb => cb.checked)
        .map(cb => `${cb.value}-${portSlug}`);


      // --- ÉTAPE 2 : Comparer les listes ---
      // Sujets à ajouter : ceux qui sont dans la nouvelle liste mais pas dans l'ancienne
      const topicsToSubscribe = newTopics.filter(topic => !initialTopics.includes(topic));

      // Sujets à supprimer : ceux qui sont dans l'ancienne liste mais pas dans la nouvelle avec le même portSlug
      const topicsToUnsubscribe = initialTopics
        .filter(topic => topic.endsWith(`-${portSlug}`))
        .filter(topic => !newTopics.includes(topic));

      // console.log('Sujets à ajouter:', topicsToSubscribe);
      // console.log('Sujets à supprimer:', topicsToUnsubscribe);


      // --- ÉTAPE 3 : Envoyer les changements au serveur ---

      // On lance les deux appels en parallèle pour plus d'efficacité
      await Promise.all([
        this.firebaseService.subscribeToTopics(topicsToSubscribe),
        this.firebaseService.unsubscribeFromTopics(topicsToUnsubscribe)
      ]);

      // Feedback visuel de succès
      if (portNameSpans.length > 0 && portHiddenInput) {
        let portValue = portSlug;
        const lowerPortValue = portValue.toLowerCase();
        if (lowerPortValue === 'le-havre') {
          portValue = 'du Havre';
        } else if (lowerPortValue === 'paris') {
          portValue = 'de Paris';
        } else if (lowerPortValue === 'rouen') {
          portValue = 'de Rouen';
        }

        portNameSpans.forEach(span => {
          span.textContent = portValue;
        });
      }
      const checkedCheckboxes = Array.from(this.thematiqueCheckboxes).filter(cb => cb.checked);
      if (checkedCheckboxes.length > 0) {
        const selectedThemeNames = checkedCheckboxes.map(cb => {
          const label = this.form?.querySelector(`label[for="${cb.id}"] .page-notifications__form-title`);
          return label ? label.textContent?.trim() : cb.value;
        });


        if (themesNameSpan) {
          const list = selectedThemeNames.map(name => `<li>${name}</li>`).join('');
          themesNameSpan.innerHTML = `<ul>${list}</ul>`;
        }
        // 3. Affichage du bloc de confirmation
        confirmationDiv?.classList.add('active');
        disabledNotification?.classList.remove('active');
      } else {
        confirmationDiv?.classList.remove('active');
        disabledNotification?.classList.add('active');
      }
      this.submitButton!.textContent = messages.success;

    } catch (error) {
      console.error('Erreur lors de la mise à jour des abonnements:', error);
      // Feedback visuel d'erreur
      this.submitButton!.textContent = messages.error;
    } finally {
      // On réactive le bouton après un court délai pour que l'utilisateur voie le message de succès/erreur
      setTimeout(() => {
        this.submitButton!.disabled = false;
        this.submitButton!.textContent = messages.submit;
      }, 2000);
    }
  }

}

export const pageNotifications = new PageNotifications();
